import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Input, Select, Button, Card } from 'antd';
import Loading from '../../Loading';
import { getOTACodes } from './../../../services/common';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { getHelper, putHelper } from './helpers';
import PageContainer from '../../CSIComponents/PageContainer';

interface typeTypes {
  codeName?: string | undefined,
  codeType?: string | undefined,
  codeValue?: string | undefined,
  id?: number | undefined,
  subCat?: null
}
interface detailsType {
  additionaltype1?: string | null,
  additionaltype2?: string | null,
  additionaltype3?: string | null,
  isocertified?: string | null,
  markettier?: string | null,
  markettieradditional?: string | null,
  markettiersecondary?: string | null,
  ohg?: string | null,
  primarytype?: string | null,
  secondarytype?: string | null
}
interface generalType {
  result?:{
    success:boolean
  },
  property?: { 
    affiliations?: { 
      affiliationgeneral:detailsType
    } 
  }
}
const Option = Select.Option
const markerTierOptions = ['Economy', 'Midscale', 'Upper Midscale', 'Upscale', 'Upper Upscale', 'Luxury']
const ohgOptions = ['Deluxe', 'First Class', 'Limited First Class', 'Moderate Deluxe', 'Moderate First Class', 'Moderate Tourist', 'Not Listed', 'Superior Deluxe', 'Superior First Class', 'Superior Tourist', 'Tourist']
const AffiliationGeneral = ()=>{
   const [form] = Form.useForm();
   const [isEditModle, setIsEditModle] = useState<boolean>(false)
   const [disableFlag, setDisableFlag] = useState<boolean>(false)
   const [loadingFlag, setLoadingFlag] = useState<boolean>(false)
  // const [activeTabKeys, setActiveTabKeys] = useState<string[] | string>(getDefaultOpenKeys(dataSource))
  const [RATOptions, setRATOptions] = useState<typeTypes[]>([])
  const [details, setDetails] = useState<detailsType | undefined>(undefined)
  const validateForm = (changeFlag?:boolean)=>{
    if(!isEditModle){
      return 
    }
    form.validateFields().then(() => {
      //if click cancel, do not change disableFlag
      !changeFlag && setDisableFlag(false)
    }).catch((err: { errorFields: { length: number }}) => {
      err?.errorFields?.length ? setDisableFlag(true) : setDisableFlag(false)
    });
  }
  const getAllOptions = async () => {
    const res = await getOTACodes('RAT', '')
    const options = res?.otacodes || []
    setRATOptions(options)
  }

  const getGeneralData = async()=>{
    const response:generalType = await getHelper('/property/affiliations')
    if(response?.result?.success){
      const _details = response?.property?.affiliations?.affiliationgeneral
      setDetails(_details)
      form.setFieldsValue(_details)
    }
  }

  const cancelFun = ()=>{
    //validate for clear error message
    validateForm(true)
    setIsEditModle(false)
    form.resetFields()
  }

  const saveDetail = async ()=>{
    try{
      setDisableFlag(true)
      setLoadingFlag(true)
      const values = form.getFieldsValue()
      const property = {
        affiliations: {
            affiliationgeneral: values
        }
      }
      const response = (await putHelper('/property/affiliations/general', {
        property,
      })) as generalType
      if (response?.result?.success) {
        setDisableFlag(false)
        setLoadingFlag(false)
        setIsEditModle(false)
      }
    }catch(error){
      console.log(error)
    }
  }
  // useEffect(validateForm,[activeTabKeys])
  const initFun = async()=>{
    setLoadingFlag(true)
    await getGeneralData()
    await getAllOptions()
    setLoadingFlag(false)
  }
  useEffect(()=>{
    initFun()
    return ()=>{
      setDisableFlag(false)
      setLoadingFlag(false)
    }
  },[])
  return (
    <PageContainer>
      <Card
        title='General'
        headStyle={{ fontWeight: 600, fontSize: 14, color: '#333' }}
        style={{ marginTop: -13 }}
        extra={
          isEditModle ? null : (
            <Button
              type='primary'
              className='db-edit-btn'
              onClick={() => setIsEditModle(true)}>
              Edit
            </Button>
          )
        }>
        {loadingFlag && (
          <div className='contact-person-loading-wrap'>
            <Loading type='large' />
          </div>
        )}
        {details && (
          <Form
            layout='vertical'
            form={form}
            onValuesChange={() => {
              validateForm()
            }}
            initialValues={details}
            style={isEditModle ? {} : { pointerEvents: 'none' }}>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label='Primary Property Type'
                  name='primarytype'
                  rules={
                    isEditModle
                      ? [{ required: true, message: 'This field is required' }]
                      : []
                  }>
                  <Select allowClear showSearch>
                    {RATOptions.map((item: typeTypes, index: number) => {
                      return (
                        <Option key={index} value={item.codeName as string}>
                          {item.codeName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label='Secondary Property Type' name='secondarytype'>
                  <Select allowClear showSearch>
                    {RATOptions.map((item: typeTypes, index: number) => {
                      return (
                        <Option key={index} value={item.codeName as string}>
                          {item.codeName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label='Additional Property Type 1'
                  name='additionaltype1'>
                  <Select allowClear showSearch>
                    {RATOptions.map((item: typeTypes, index: number) => {
                      return (
                        <Option key={index} value={item.codeName as string}>
                          {item.codeName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label='Additional Property Type 2'
                  name='additionaltype2'>
                  <Select allowClear showSearch>
                    {RATOptions.map((item: typeTypes, index: number) => {
                      return (
                        <Option key={index} value={item.codeName as string}>
                          {item.codeName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label='Additional Property Type 3'
                  name='additionaltype3'>
                  <Select allowClear showSearch>
                    {RATOptions.map((item: typeTypes, index: number) => {
                      return (
                        <Option key={index} value={item.codeName as string}>
                          {item.codeName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label='Market Tier'
                  name='markettier'
                  rules={
                    isEditModle
                      ? [{ required: true, message: 'This field is required' }]
                      : []
                  }>
                  <Select allowClear showSearch>
                    {markerTierOptions.map((item: string, index: number) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label='Secondary Market Tier'
                  name='markettiersecondary'>
                  <Select allowClear showSearch>
                    {markerTierOptions.map((item: string, index: number) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label='Additional Market Tier'
                  name='markettieradditional'>
                  <Select allowClear showSearch>
                    {markerTierOptions.map((item: string, index: number) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label='ISO Certified ' name='isocertified'>
                  <Select allowClear showSearch>
                    <Option value='Yes'>Yes</Option>
                    <Option value='No'>No</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label='OHG (Hotel & Travel Index)' name='ohg'>
                  <Select allowClear showSearch>
                    {ohgOptions.map((item: string, index: number) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        <ActionButtonsBar
          onCancel={cancelFun}
          onSave={saveDetail}
          disabledSave={disableFlag}
          show={isEditModle}
        />
      </Card>
    </PageContainer>
  )
          
}

export default AffiliationGeneral;
